import { inject } from '@angular/core';
import {
  HttpInterceptorFn
} from '@angular/common/http';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  
  const publicEndpoints = [
    'service/user/signup',
    'service/user/fullsignup',
    'service/user/send_email_verification_code',
    'service/user/validate_email_verification_code',
    'service/user/send_phone_number_verification_code',
    'service/user/validate_phone_number_verification_code',
    'service/user/signin',
    'service/user/resetpassword',
    'service/user/verifyresetpassword',
    'service/user/changepassword',
    'assets/',
    '/assets/i18n/'
  ];
  const isPublic = publicEndpoints.some(endpoint => req.url.includes(endpoint)) || req.url.endsWith('.json');

  if (isPublic) {
    return next(req);
  }

  const authSrv = inject(AuthService);
  var token = authSrv.getAuthToken();
  if (token) {
    const clonedRequest = req.clone({
      setHeaders: {
        'Auth-Token': token
      }
    });
    // console.log(clonedRequest);
    return next(clonedRequest);
  }

  return next(req);
};